import { h, Component, Prop, Element } from '@stencil/core';

/**
 * COMPNAME is for designed for rendering tab panels inside a tab container
 *
 * <em>For More Information:</em>
 * AEM Component- ui.apps/src/main/content/jcr_root/apps/brand/aafp/components/content/aafp-tab-item
 * Sling Model- core/src/main/java/org/aafp/aem/core/models/tabs/AafpTabComponentModel.java
 */
@Component({
  tag: 'aafp-tab-item',
  shadow: false,
})
export class AafpTabItem {
  /**
   * The title of the tab panel that will display as the heading for the tab content
   */
  @Prop() dataTitle!: string;
  @Element() element: HTMLElement;
  tab: Element;

  addTabToContainer() {
    const container: any = this.element.closest('aafp-tab-container');
    if (container) {
      const callback = () => {
        return {
          tab: this.tab,
          title: this.dataTitle,
        };
      };
      container.addTab(callback.bind(this));
    }
  }

  render() {
    this.addTabToContainer();
    return (
      <div class="adl-tab" ref={(el) => (this.tab = el as Element)}>
        <button class="adl-tab__title">{this.dataTitle}</button>
        <div role="tabpanel" class="adl-tab__content--default">
          <slot name="data-tab-content"></slot>
        </div>
      </div>
    );
  }
}
